export const CENTER_TEXTS = {
    PLAN: 'Plan',
    USAGE_TIER: 'Usage Tier',
    AD_SPENT: 'Past 30d Ad Spent',
    NEXT_INVOICE: 'Next invoice Estimation',
};

export const BILLING_CENTER = 'billingCenter';
